import React from 'react';

import TablePagination from '@material-ui/core/TablePagination';

type InputProps = {
  count: number;
  offset: number;
  handleOffsetChange: (offset: number) => void;
};

export const ACCOUNT_PAGE_SIZE = 20;

export const AccountTablePagination = ({
  count,
  offset,
  handleOffsetChange: handleChangePage,
}: InputProps) => {
  const handleFullChangePage = (
    _event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    page: number,
  ) => {
    handleChangePage(page * ACCOUNT_PAGE_SIZE);
  };

  return (
    <TablePagination
      component="div"
      count={count}
      rowsPerPage={ACCOUNT_PAGE_SIZE}
      page={offset / ACCOUNT_PAGE_SIZE}
      backIconButtonProps={{
        'aria-label': 'Previous Page',
        size: 'small',
      }}
      nextIconButtonProps={{
        'aria-label': 'Next Page',
        size: 'small',
      }}
      onPageChange={handleFullChangePage}
      rowsPerPageOptions={[ACCOUNT_PAGE_SIZE]}
    />
  );
};
